<template>
  <div id="home">
    <PortalSidebar :selectedClients="selectedClients" :clients="clients" @cschange="clientSelectionChanged"/>
    <div class="page-container">
      <PortalPageHeader/>
      <main class="main-content">
        <router-view :selectedClients="selectedClients"></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import PortalSidebar from "@/components/PortalSidebar.vue";
import PortalPageHeader from "@/components/PortalPageHeader.vue";

import { getUser } from "@/services/api";
import { getCurrentUser, storeUserSession } from "@/services/usersession";
import {
  storeClients,
  getClients,
  storeUser
} from "@/services/localstorage";

export default {
  name: "Main",
  components: {
    PortalSidebar,
    PortalPageHeader
  },
  data() {
    return {
      selectedClients: [],
      user: null,
      clients: []
    }
  },
  async mounted() {
    // retrieve user from session
    this.user = getCurrentUser(this.$session);

    // the session user can be out of date/not updated, so:
    let user = await getUser(this.user.id);
    this.user = user;
    await storeUserSession(user, this.$session);
    await storeUser(user);

    this.clients = this.user.clients;

    const storedClients = getClients();

    if(storedClients) {
      // cleanup any clients we should not have
      for(let i = storedClients.length - 1; i >= 0; i--) {
        let found = false;
        for(let j = 0; j < this.clients.length; j++) {
          const cc = this.clients[j];
          const sc = storedClients[i];
          if(cc.id === sc.id) {
            found = true;
          }
        }
        if(!found) {
          // remove this client
          storedClients.splice(i, 1);
        }
      }
      // save it
      storeClients(storedClients);
    }

    this.selectedClients = storedClients ? storedClients : this.clients;

    // extra check - we need at least one selected client, or always select the only client
    if (this.clients.length === 1 || this.selectedClients.length < 1) {
      this.selectedClients = this.user.clients;
    }
  },
  methods: {
    clientSelectionChanged(data) {
      this.selectedClients = data;
      storeClients(this.selectedClients);
    }
  }
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";
</style>



// WEBPACK FOOTER //
// src/views/Main.vue